<template>
  <div class="step-container start">
    <div class="step-header">
      <h2 class="step-title start">Der s Immobilienkalkulator</h2>
      <p class="step-text start">
        So erhalten Sie sofort eine erste Einschätzung darüber, wieviel eine
        Immobilie wert ist.
      </p>
    </div>
    <div class="step-body">
      <div class="body-title">Wählen Sie Ihre Immobilie</div>
      <div class="box-container">
        <ActionBox
          text="Haus"
          @click="setType('haus')"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_7072.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_-1.svg')"
          class="box-item small-icon-w-50"
        />
        <ActionBox
          text="Wohnung"
          @click="setType('wohnung')"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8128.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8343.svg')"
          class="box-item small-icon-w-50"
        />
        <ActionBox
          text="Dachgeschoss-<br/>wohnung"
          @click="setType('dg-wohnung')"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8608_primary.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8608.svg')"
          class="box-item small-icon-w-50"
        />
        <ActionBox
          text="Reihenhaus/<br/>Doppelhaus"
          @click="setType('reihenhaus')"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8159.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8159_white.svg')"
          class="box-item small-icon-w-80"
        />
        <ActionBox
          text="Baugrundstück"
          @click="setType('baugrundstueck')"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8189.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8189_white.svg')"
          class="box-item small-icon-w-80"
        />
      </div>
    </div>
  </div>
</template>
<script>
import ActionBox from "@/components/shared/ActionBox.vue";
import { saveToStorage } from "@/utils.js";
export default {
  name: "start-step-component",
  components: {
    ActionBox,
  },
  data() {
    return {
      fields: {
        type: {
          value: null,
        },
      },
    };
  },
  methods: {
    setType(type) {
      saveToStorage(this.fields);
      switch (type) {
        case "haus":
          this.$router.push("/haus-step-1");
          break;
        case "wohnung":
        saveToStorage({  indexWhgObjektKategorie: '10'})

          this.$router.push("/wohnung-step-1");
          break;
        case "dg-wohnung":
saveToStorage({  indexWhgObjektKategorie: '90'})
          // saveToStorage({ flagDachgeschoss: "true" });
          this.$router.push("/dg-wohnung-step-1");
          break;
          case "reihenhaus":
          saveToStorage({  indexWhgObjektKategorie: '20'})
          this.$router.push("/reihenhaus-step-1");
          break;
          case "baugrundstueck":
          this.$router.push("/baugrundstueck-step-1");
          break;
      }
    },
  },
  mounted() {
    this.$emit("setStep", "start", 1);
  },
};
</script>
<!-- <style scoped>
.step-header {
  margin-bottom: 0;
}

.box-container {
  gap: 30px;
}
.box-item {
  flex-basis: 180px;
  height: 190px;
}

.body-title {
  margin-top: 50px;
  margin-bottom: 55px;
}
@media only screen and (max-width: 768px) {
  .box-container {
    gap: 20px;
  }
  .box-item {
    height: 100%;
  }
  .body-title {
    margin-top: 30px;
    margin-bottom: 25px;
    text-align: left;
  }
}
</style> -->
